import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ScoreList from '../ScoreList';
import Karaoke from '../Karaoke';
import App from '../App';

// Strumenti di debug:
import InstrumentsTest from '../instruments/InstrumentsTest';
import NoteHelperTest from '../pitch/NoteHelperTest';

const AppRouter = props => {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path={process.env.PUBLIC_URL + '/'} exact component={ScoreList} />
          <Route path={process.env.PUBLIC_URL + '/instruments_test'} component={InstrumentsTest} />
          <Route path={process.env.PUBLIC_URL + '/notehelper_test'} component={NoteHelperTest} />
          <Route path={process.env.PUBLIC_URL + '/:score_id'} exact component={App} />
          <Route path={process.env.PUBLIC_URL + '/:score_id/karaoke'} exact component={Karaoke} />
          <Route path={process.env.PUBLIC_URL + '/:score_id/:mode_id'} exact component={App} />
        </Switch>
      </div>
    </Router>
  );
};

export default AppRouter;
